module.exports = angular
  .module("directives.iframeonload", [])
  .directive("iframeonload", function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('load', function () {
          var href;
          try {
            href = element[0].contentWindow.location.href;
          } catch (e) {
            
          }

          var expressionHandler = $parse(attrs.iframeonload);
          expressionHandler(scope, { href: href });
        });
      }
    }
  });

